// ===========================================
// DevPad Frontend Entry Point
// ===========================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { datadogLogs } from '@datadog/browser-logs';
import App from './App';
import './styles/index.scss';

// ===========================================
// Initialize Datadog Browser Logging
// Captures frontend errors and logs to Datadog
// ===========================================
datadogLogs.init({
  clientToken: 'pub754ae3bbbc54fb84a74a3136a473a405',
  site: 'us5.datadoghq.com',
  forwardErrorsToLogs: true,    // Automatically capture console.error calls
  sessionSampleRate: 100         // Capture 100% of sessions
});

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

